<template>
  <div>
    <!-- Main container -->
    <br>
    <nav class="level">
      <!-- Left side -->
      <div class="level-left">
        <div class="level-item">
          <p class="subtitle is-5" v-if="!loadingInstrumentosFiltro">
            <strong v-if="instrumentosFiltro.length">{{instrumentosFiltro.length}}</strong>&nbsp;
            <span v-if="instrumentosFiltro.length > 1">instrumentos</span>
            <span v-if="instrumentosFiltro.length === 1">instrumento</span>
          </p>
          <a class="button is-text is-loading" v-if="loadingInstrumentosFiltro">
            
          </a>

        </div>
        <div class="level-item">
          <div class="field">

            <div class="control has-icons-left">
              <input v-model="termoBusca" class="input is-rounded" v-bind:class="{'is-loading': loadingInstrumentosFiltro}" type="text" placeholder="Buscar instrumento">

              <span class="icon is-medium is-left">
                <i class="fas fa-search"></i>
              </span>
            </div>

          </div>
        </div>

      </div>

      <!-- Right side -->
      <div class="level-right">
        <div class="tabs is-centered filtro-instrumentos-tabs" style="margin-top: 6px;">
          <ul>
            <li v-bind:class="{'is-active': filtroSituacao==='TODOS'}">
              <a @click="filtroSituacao='TODOS'">Todos</a>
            </li>
            <li v-bind:class="{'is-active': filtroSituacao==='CALIBRADO'}">
              <a @click="filtroSituacao='CALIBRADO'">Calibrados</a>
            </li>
            <li v-bind:class="{'is-active': filtroSituacao==='ALERTA_VENCIMENTO'}">
              <a @click="filtroSituacao='ALERTA_VENCIMENTO'">
                <span class="icon is-small has-text-warning"><i class="fas fa-exclamation-circle" aria-hidden="true"></i></span>
                <span>Alerta</span>
              </a>
            </li>
            <li v-bind:class="{'is-active': filtroSituacao==='VENCIDO'}">
              <a @click="filtroSituacao='VENCIDO'">
                <span class="icon is-small has-text-danger"><i class="fas fa-exclamation-circle" aria-hidden="true"></i></span>
                <span>Alerta</span>                  
              </a>
            </li>
            <li v-bind:class="{'is-active': filtroSituacao==='INATIVO'}">
              <a @click="filtroSituacao='INATIVO'">Inativos</a>
            </li>
          </ul>
        </div>
      </div>

    </nav>

    <div class="columns">
      <div class="column">
        <div>
          <p class="subtitle is-5" v-if="!loadingInstrumentosFiltro && instrumentosFiltro.length === 0">
            <span>Nenhum instrumento encontrado</span>
          </p>
          <article class="media" v-for="inst in instrumentosFiltro">
            <div class="media-content">
              <router-link :to="{ path: 'instrumento/'+inst.id+'/certificado'}" class="has-text-black">

                <div class="media-content">
                  <div class="content">
                    <div>
                      {{inst.descricao}}
                    </div>
                    
                    <span class="tag" v-bind:class="[inst.status.cor]">{{inst.status.textoCap}}</span>&nbsp;

                    <span v-if="inst.statusChecagem" class="tag" v-bind:class="[inst.statusChecagem.cor]">{{inst.statusChecagem.texto}}</span>

                  </div>
                </div>
              </router-link>
              
            </div>
            <div class="media-right" style="padding-right: 10px;">
              <a @click="informacoesInstrumento(inst.id)">
                <small class="">
                  <span class="fa fa-info-circle has-text-grey-light" aria-hidden="true"></span>
                </small>
              </a>
            </div>
          </article>
        </div>

      </div>
    </div>

    <!-- #exibicao rapida -->
    <div class="modal modal-fx-fadeInScale" v-if="instExibicaoRapida" v-bind:class="instrumentState.modals.exibicaoRapida ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <h6 class="title is-6">Informações sobre o instrumento: </h6>
          <div class="">
            <strong>Descrição:</strong> {{instExibicaoRapida.item.descricao}}
          </div>
          <div class="">
            <strong>Modelo:</strong> {{instExibicaoRapida.item.modelo}}
          </div>
          <div class="">
            <strong>Número de série:</strong> {{instExibicaoRapida.item.numeroserie}}
          </div>
          <div class="">
            <strong>Fabricante:</strong> {{instExibicaoRapida.item.fabricante}}
          </div>
          <div class="">
            <strong>Identificação:</strong> {{instExibicaoRapida.item.identificacao}}
          </div>
          <div class="">
            <strong>Patrimônio:</strong> {{instExibicaoRapida.item.patrimonio}}
          </div>
          <div class="">
            <strong>Data última calibração:</strong> {{dataUltimaCalExibicaoRapida}}
          </div>
          <div class="" v-if="['VENCIDO', 'CALIBRADO'].indexOf(instExibicaoRapida.status.situacao) !== -1">
            <strong>Data próxima calibração:</strong> {{dataProximaCalExibicaoRapida}}
          </div>

          <div class="" v-if="instExibicaoRapidaDados && instExibicaoRapidaDados.calibracoes"><strong>Certificado:</strong> {{instExibicaoRapidaDados.calibracoes[0].Certificado}}</div>

          <div class="">
            <strong>Orgão Calibrador:</strong> {{instExibicaoRapidaDados.orgao || 'IPT/LME'}}
          </div>

          <div v-if="instExibicaoRapida.configPeriodicidade && instExibicaoRapida.configPeriodicidade.localizacao">
            <strong>Localização:</strong> {{ instExibicaoRapida.configPeriodicidade.localizacao }}
            
          </div>

          <div v-if="instExibicaoRapida.configPeriodicidade && instExibicaoRapida.configPeriodicidade.tecnicoResponsavel">
            <strong>Responsável:</strong> {{ instExibicaoRapida.configPeriodicidade.tecnicoResponsavel }}
          </div>


          <br>
          <p v-if="faixaDeUtilização.length">
            <strong>Faixa de utilização:</strong>
            <ul v-for="f in faixaDeUtilização">
              <li class="faixa-utilizacao">{{f}}</li>
            </ul>
          </p>
          

        </div>
      
      </div>
      <button class="modal-close is-large" aria-label="close" @click="instrumentState.modals.exibicaoRapida = false"></button>
    </div>
    <!-- /exibicao rapida -->

  </div>
  
</template>

<script>

import PouchDB from 'pouchdb'
import pouchAuth from 'pouchdb-authentication'
import Fuse from 'fuse.js'
import moment from '../momentLocale'
PouchDB.plugin(pouchAuth);

  
export default {
  name: 'Instrumentos',
  props: [],
  data () {
    return {
      instrumentState: INSTRUMENT_STORE.state,
      termoBusca: '',
      filtroSituacao: 'TODOS',
      instExibicaoRapida: null,
      instExibicaoRapidaDados: null,
    }
  },
  created () {
  },
  methods: {
    informacoesInstrumento (id) {
      let inst = this.instrumentos.filter((inst) => inst.id === id)[0]
      if (inst) {
        INSTRUMENT_STORE.state.db.get(inst.id).then((data) => {
          this.instExibicaoRapidaDados = data
          this.instExibicaoRapida = inst
          this.$nextTick(() => {
            this.instrumentState.modals.exibicaoRapida = true
          })
        })
      }
    }
  },
  computed: {
    faixaDeUtilização () {
      if (!this.instExibicaoRapidaDados) return []
      if (!this.instExibicaoRapidaDados.calibracoes) return []
      if (!this.instExibicaoRapidaDados.calibracoes.length) return []

      return this.instExibicaoRapidaDados.calibracoes[0].Faixas.map((item) => item.DescFaixa)
    },
    dataUltimaCalExibicaoRapida () {
      if (this.instExibicaoRapida) {
        return moment(this.instExibicaoRapida.status.dataUltimaCal, moment.defaultFormat).format('DD/MM/YYYY')
      }
    },
    dataProximaCalExibicaoRapida () {
      if (this.instExibicaoRapida) {
        console.log(this.instExibicaoRapida)
        return moment(this.instExibicaoRapida.status.dataProximaCal, moment.defaultFormat).format('DD/MM/YYYY')
      }
    },
    loadingInstrumentosFiltro () {
      return this.instrumentos.length === 0
    },
    instrumentos () {
      var res = Object.keys(this.instrumentState.instrumentos).map((instKey) => {
        return this.instrumentState.instrumentos[instKey]
      })
      var resSorted = _.sortBy(res, (item) => item.descricao)
      return resSorted
    },
    instrumentosFiltro () {

      var instrumentosFiltro
      if (this.filtroSituacao === 'TODOS') {
        instrumentosFiltro = this.instrumentos
      } else {
        instrumentosFiltro = this.instrumentos.filter((inst) => {
          return (inst.status.situacao === this.filtroSituacao) || (inst.statusChecagem && inst.statusChecagem.situacao === this.filtroSituacao)
        })
      }

      if (!this.termoBusca.length) {
        return instrumentosFiltro
      }

      var options = {
        shouldSort: true,
        threshold: 0.3,
        location: 0,
        distance: 500,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
          'item.descricao',
          'item.fabricante',
          'item.modelo',
          'item.identificacao',
          'item.numeroserie',
          'item.patrimonio'
        ]
      };

      var fuse = new Fuse(instrumentosFiltro, options)
      var res = fuse.search(this.termoBusca);

      /*var res = instrumentosFiltro.filter((inst) => {
        return inst.descricao.indexOf(this.termoBusca) !== -1
      })*/
      return res.map((x) => x.item)
    }
  }
}
</script>

<style scoped>
.faixa-utilizacao {
  padding: 2px;
  margin: 4px;
  list-style: circle;
}
.icone-instrumentos-direita {
  position: relative;
}
</style>
